// src/pages/Creator/CreatorHub.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BRAND_GREEN, BRAND_GOLD, BRAND_GREEN_LIGHT } from '../../theme/sucronTheme';


const BRAND_DARK = '#0f1a13';
const BORDER = '#E5E7EB';

// UI Primitives (padrão Design System ArenaStats)
const PageShell = ({ children }) => (
  <div className="min-h-screen" style={{ backgroundColor: '#f8fafc' }}>
    <div className="max-w-7xl mx-auto px-4 lg:px-6 py-6">
      {children}
    </div>
  </div>
);

const Card = ({ children, className = '' }) => (
  <div
    className={`bg-white rounded-2xl border ${className}`}
    style={{ borderColor: BORDER, boxShadow: '0 1px 2px 0 rgba(6, 78, 59, 0.05)' }}
  >
    {children}
  </div>
);

const CardTitle = ({ children }) => (
  <h3 className="text-sm font-extrabold uppercase tracking-wider" style={{ color: BRAND_GREEN, opacity: 0.7 }}>
    {children}
  </h3>
);

const Icons = {
  Video: () => (
    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
    </svg>
  ),
  Editorial: () => (
    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
    </svg>
  ),
  Card: () => (
    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
    </svg>
  ),
  Publish: () => (
    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 1 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
    </svg>
  ),
  Compare: () => (
    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
    </svg>
  ),
  Template: () => (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 5a1 1 0 011-1h4a1 1 0 011 1v7a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM14 5a1 1 0 011-1h4a1 1 0 011 1v7a1 1 0 01-1 1h-4a1 1 0 01-1-1V5zM4 16a1 1 0 011-1h4a1 1 0 011 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-3zM14 16a1 1 0 011-1h4a1 1 0 011 1v3a1 1 0 01-1 1h-4a1 1 0 01-1-1v-3z" />
    </svg>
  ),
  Sparkles: () => (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
    </svg>
  ),
};

const CreatorHub = () => {
  const features = [
    {
      title: 'Vídeos & Análise Visual',
      description: 'Crie highlights automáticos, análises táticas e conteúdo visual com IA generativa.',
      icon: Icons.Video,
      to: '/creator/videos',
      status: 'Em Desenvolvimento',
      color: 'from-purple-500 to-purple-700'
    },
    {
      title: 'Editorial Engine',
      description: 'Crie insights analíticos com radar charts, comparativos e visualizações prontas.',
      icon: Icons.Editorial,
      to: '/servicos/editorial-engine',
      status: 'Disponível',
      color: 'from-gray-700 to-gray-900'
    },
    {
      title: 'Cards & Insights',
      description: 'Transforme dados em cards visuais para compartilhar em redes sociais.',
      icon: Icons.Card,
      to: '/creator/cards',
      status: 'Em Breve',
      color: 'from-amber-500 to-amber-700'
    },
    {
      title: 'Comparativos Lite',
      description: 'Compare jogadores rapidamente com widgets prontos para postar.',
      icon: Icons.Compare,
      to: '/creator/compare-lite',
      status: 'Beta',
      color: 'from-blue-500 to-blue-700'
    },
    {
      title: 'Publicações',
      description: 'Publique conteúdo diretamente no feed social do Arena Stats.',
      icon: Icons.Publish,
      to: '/creator/publish',
      status: 'Disponível',
      color: 'from-rose-500 to-rose-700'
    },
  ];

  return (
    <PageShell>
      {/* Hero Section */}
      <div 
        className="relative overflow-hidden"
        style={{
          background: `linear-gradient(135deg, ${BRAND_GREEN} 0%, #374151 100%)`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
          <div className="text-center">
            <div className="flex items-center justify-center mb-6">
              <svg className="w-16 h-16 text-white opacity-90" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
              </svg>
            </div>
            <h1 className="text-4xl sm:text-5xl font-black text-white mb-4">
              Creator Studio
            </h1>
            <p className="text-xl text-white opacity-90 max-w-3xl mx-auto font-semibold">
              Transforme dados esportivos em conteúdo visual pronto para compartilhar. 
              Vídeos, insights, comparativos e cards — tudo em um único estúdio.
            </p>
            <div className="mt-8 flex items-center justify-center gap-3">
              <div className="px-4 py-2 rounded-full text-sm font-bold" style={{ backgroundColor: BRAND_GOLD, color: BRAND_GREEN }}>
                🎨 Criação de Conteúdo
              </div>
              <div className="px-4 py-2 rounded-full bg-white bg-opacity-20 text-white text-sm font-bold">
                🤖 IA Generativa
              </div>
              <div className="px-4 py-2 rounded-full bg-white bg-opacity-20 text-white text-sm font-bold">
                ⚡ Publicação Rápida
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Features Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {features.map((feature, index) => (
          <Link key={index} to={feature.to} className="block group">
            <Card className="p-6 hover:shadow-md transition-all duration-300 h-full relative">
              {/* Icon & Status */}
              <div className="flex items-start justify-between mb-4">
                <div className="p-3 rounded-xl" style={{ backgroundColor: BRAND_GREEN_LIGHT }}>
                  <div style={{ color: BRAND_GREEN }}>
                    <feature.icon />
                  </div>
                </div>
                <span className="text-xs font-bold px-3 py-1 rounded-full" 
                      style={{ backgroundColor: BRAND_GREEN_LIGHT, color: BRAND_GREEN }}>
                  {feature.status}
                </span>
              </div>

              {/* Content */}
              <h3 className="text-lg font-extrabold mb-2 group-hover:scale-105 transition-transform" 
                  style={{ color: BRAND_GREEN }}>
                {feature.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {feature.description}
              </p>

              {/* Hover Border */}
              <div className="absolute inset-0 border-2 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity" 
                   style={{ borderColor: BRAND_GOLD, pointerEvents: 'none' }} />
            </Card>
          </Link>
        ))}
      </div>

      {/* CTA Section */}
      <div className="mt-12">
        <Card className="p-12 text-center" style={{ background: `linear-gradient(135deg, ${BRAND_GREEN} 0%, #374151 100%)` }}>
          <h2 className="text-3xl font-black text-white mb-4">
            Pronto para criar?
          </h2>
          <p className="text-white text-lg opacity-90 mb-8 max-w-2xl mx-auto">
            O Creator Studio une o melhor da análise esportiva com ferramentas de criação de conteúdo. 
            Comece agora e transforme seus insights em publicações engajantes.
          </p>
          <Link
            to="/servicos/editorial-engine"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
            style={{ backgroundColor: BRAND_GOLD, color: BRAND_GREEN }}
          >
            <Icons.Editorial />
            <span>Abrir Editorial Engine</span>
          </Link>
        </Card>
      </div>
    </PageShell>
  );
};

export default CreatorHub;
